import { hashKey, QueryFilters } from '@tanstack/react-query';
import { DashboardItemDto } from '@unistocks/proxy/axios-client';
import { dashboardGetEventViewDataQueryKey } from '@unistocks/proxy/axios-client/DashboardQuery';

export const queryFilter = ({ id, settings }: DashboardItemDto): QueryFilters | null => {
  if (settings.values) {
    const queryHashes = settings.values.reduce<string[]>((functions, _, index) => {
      functions.push(hashKey(dashboardGetEventViewDataQueryKey({ id, index })));

      return functions;
    }, []);

    return { predicate: ({ queryHash }) => queryHashes.some(hash => hash === queryHash) };
  }

  return null;
};
